/* eslint-disable-next-line import/no-unresolved,import/extensions */
import '../stylesheets/certificate';

$(document).ready(() => {
  if ($('.new_certificate_form').length > 0) {
    $('#certificate_form_control_code').mask('CCCC.CCCC.CCCC.CCCC', {
      translation: {
        C: {
          pattern: /[A-Za-z0-9]/,
        },
      },
      onKeyPress(value, event) {
        event.currentTarget.value = value.toUpperCase();
      },
    });
  }

  if ($('div#confirmCertificateModal').length > 0) {
    $('a#generateCertificate').click(() => {
      setTimeout(() => {
        $('div#confirmCertificateModal').modal('hide');
      }, 100);
    });
  }
});
